export default __webpack_public_path__ + "static/media/callable-final-design-01.36ea40b0.png";